import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, ButtonStyled} from '@tickchak/react-share/app';
import type {AiAgentSuggestionConfig} from '../../constants';

export type AiAgentSuggestionItem = AiAgentSuggestionConfig & {catalogIndex: number};

interface AiAgentSuggestionChipProps {
    suggestion: AiAgentSuggestionItem;
    /** The file dialog was asked for and has not shown up yet. */
    loading: boolean;
    onSelect: (suggestion: AiAgentSuggestionItem) => void;
}

function AiAgentSuggestionChip({suggestion, loading, onSelect}: AiAgentSuggestionChipProps) {
    const {t} = useTranslation('aiAgent');
    const {Icon, labelKey, catalogIndex} = suggestion;

    const handleClick = useCallback(() => onSelect(suggestion), [onSelect, suggestion]);

    return (
        <Button
            variant="neutral"
            size="category"
            // The library's own spinner, in the icon slot rather than via `xhrState` — that
            // hides the label too, and the chip would collapse and reflow the row.
            iconStart={loading
                ? <ButtonStyled.LoadingSpinner data-cy={`account-ai-agent-suggestion-loader-${catalogIndex}`} />
                : <Icon width={20} height={20} stroke="currentColor" />}
            disabled={loading}
            onClick={handleClick}
            data-cy={`account-ai-agent-suggestion-${catalogIndex}`}
            customStyle={{borderColor: 'var(--color-border-subtle)'}}
        >
            {t(labelKey)}
        </Button>
    );
}

export default AiAgentSuggestionChip;
